import "assets/styles/table.scss";
import { Dropdown, DropdownButton } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsis, faPenToSquare } from "@fortawesome/free-solid-svg-icons";
import { useRef, useState } from "react";
import EditAlert from "./EditAlert";
import { Toast } from "primereact/toast";
import TableColumnsMenu from "components/Ui/TableColumnsMenu/TableColumnsMenu";
import TableHead from "components/Ui/TableHead/TableHead";
import TableBodyCells from "components/Ui/TableBodyCells/TableBodyCells";
import useTableColumnsConfig from "hooks/useTableColumnsConfig";

const COLUMNS = [
    { id: "id", label: "#", width: "10px" },
    { id: "city", label: "المدينه", width: "100px" },
    { id: "content", label: "النص", width: "100px" },
    { id: "active", label: "مفعل", width: "100px" },
    { id: "actions", label: "الاعدادات", width: "50px" },
];

const Alerts = (props) => {
    const [showEditForm, setShowEditForm] = useState(false);
    const [selectedRegion, setSelectedRegion] = useState(null);
    const toast = useRef(null);
    const { orderedColumns, visibleColumns, hiddenSet, toggleColumn, moveColumn, reset } =
        useTableColumnsConfig("alerts", COLUMNS);
    const setSelectedRegionValue = (region) => {
        setSelectedRegion(region);
    };
    const toggleEditForm = () => {
        setShowEditForm((pre) => (pre = !pre));
    };
    const showMessage = (type, head, content) => {
        toast.current.show({
            severity: type,
            summary: head,
            detail: content,
            life: 3000,
        });
    };

    const buildRenderers = (region) => ({
        id: () => <td>{region.id}</td>,
        city: () => (
            <td className="name">
                <h6>{region.city?.name}</h6>
            </td>
        ),
        content: () => <td>{region.content}</td>,
        active: () => <td>{region.active ? "مفعل" : "غير مفعل"}</td>,
        actions: () => (
            <td>
                <DropdownButton
                    id="dropdown-basic-button"
                    title={<FontAwesomeIcon icon={faEllipsis} />}
                    variant="none"
                >
                    <Dropdown.Item
                        onClick={() => {
                            toggleEditForm();
                            setSelectedRegionValue(region);
                        }}
                    >
                        <FontAwesomeIcon icon={faPenToSquare} size="sm" />
                        تعديل
                    </Dropdown.Item>
                </DropdownButton>
            </td>
        ),
    });

    return (
        <div
            className="table-container surface-card"
            style={{ margin: "0 0 20px", padding: "20px" }}
        >
            {/* The heading lives inside the card, like every other card in the
                dashboard — it used to sit on the page background above it. */}
            {props.title ? <h3>{props.title}</h3> : null}
            <Toast style={{ direction: "rtl" }} ref={toast} position="top-left" />
            <div
                style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    marginBottom: "10px",
                }}
            >
                <TableColumnsMenu
                    orderedColumns={orderedColumns}
                    hiddenSet={hiddenSet}
                    toggleColumn={toggleColumn}
                    moveColumn={moveColumn}
                    reset={reset}
                />
            </div>
            <table>
                <TableHead visibleColumns={visibleColumns} />
                <tbody>
                    {props.data ? (
                        props.data.map((region) => (
                            <tr className="item" key={region.id}>
                                <TableBodyCells
                                    visibleColumns={visibleColumns}
                                    renderers={buildRenderers(region)}
                                />
                            </tr>
                        ))
                    ) : (
                        <h4>لا يوجد مدن!</h4>
                    )}
                </tbody>
            </table>
            <EditAlert
                show={showEditForm}
                close={toggleEditForm}
                showMessage={showMessage}
                region={selectedRegion}
                fetchNumbers={props.fetchNumbers}
            />
        </div>
    );
};
export default Alerts;
